import { addB2bAPIParams } from '../b2b';
import { getTenantId } from '../utils';

/**
 * @type {import('./index.d').bisGetProductById}
 */
export const getProductById = async (context, productId) => {
  if (!productId) return null;

  const params = {
    product_id: productId,
    shop: getTenantId(),
    country: window.Shopify.country || '',
  };

  if (context.app.b2b?.enabled) {
    addB2bAPIParams(params, context);
  }

  const queryParams = new URLSearchParams(params);

  const response = await fetch(`${context?.app?.productUrl}?${queryParams.toString()}`);
  if (response.status === 200) {
    const data = await response.json();
    return data;
  }

  return {};
};

/**
 * API: Subscribe to Back-in-Stock notifications
 * @type {import('./index.d').submitSubscriptionData}
 */
export const submitSubscriptionData = async (context, subscriptionData) => {
  if (!subscriptionData || !subscriptionData.email) {
    console.error('Missing required subscription data (email, variantId).');
    return { success: false, message: 'Invalid subscription data.' };
  }

  const params = {
    shop: getTenantId(),
    email: subscriptionData.email,
    product_id: subscriptionData.productId,
    variant_id: subscriptionData.variantId,
  };

  // Add B2B params if applicable
  if (context.app.b2b?.enabled) {
    addB2bAPIParams(params, context);
  }

  try {
    const response = await fetch(`${context?.app?.subscriptionUrl}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    });

    if (window.klaviyo) {
      const companyId = await window.klaviyo.account();
      let variantId = subscriptionData.variantId;
      if (!variantId) {
        variantId = window.boostSDData?.product?.variants
          ? window.boostSDData?.product?.variants[0]?.id
          : '';
      }
      if (companyId) {
        const options = {
          method: 'POST',
          headers: {
            accept: 'application/vnd.api+json',
            revision: '2025-01-15',
            'content-type': 'application/vnd.api+json',
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: subscriptionData.email,
                    },
                  },
                },
                channels: ['EMAIL'],
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${variantId}`,
                  },
                },
              },
            },
          }),
        };

        fetch(`${context?.app?.klaviyoBISUrl}?company_id=${companyId}`, options)
          .then((res) => res.json())
          .then((json) => console.log(json))
          .catch((err) => console.error(err));
      }
    }

    if (response.status === 200) {
      const data = await response.json();
      return { success: true, data };
    } else {
      const errorData = await response.json();
      console.error('Subscription failed:', errorData);
      return { success: false, message: errorData.message || 'Failed to subscribe.' };
    }
  } catch (error) {
    console.error('Error while subscribing to Back-in-Stock:', error);
    return { success: false, message: 'An unexpected error occurred.' };
  }
};
